export default __webpack_public_path__ + "static/media/loading-arrow.dd29210f.gif";